import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Col, Row, Typography, Layout, Card, Button } from "antd";
import "./contact-us.css";

import { IoMdPin } from "react-icons/io";
import { FaEnvelope } from "react-icons/fa";
import { BsFillTelephoneFill } from "react-icons/bs";

function ContactUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Childcare Health & Environmental Consulting in Bronx NY</title>
        <meta
          name="description"
          content="Contact WrightCo Academy for childcare facility health assessments and expert environmental health consulting services designed for schools in Bronx, NY."
        />
        <meta
          property="og:title"
          content="Childcare Health & Environmental Consulting in Bronx NY"
        />
        <meta
          property="og:description"
          content="Contact WrightCo Academy for childcare facility health assessments and expert environmental health consulting services designed for schools in Bronx, NY."
        />
      </Helmet>
      <Layout className="contact-page-layout">
        <Row className="blueBackground-old contactbnr contact-hero" justify="center">
          <div className="contact-hero-panel">
            <Typography.Text className="contact-hero-kicker">We Are Listening</Typography.Text>
            <Typography.Title className="fontFamily1 contactbnr-content contact-hero-title" level={1}>
              Contact Us
            </Typography.Title>
            <Typography.Paragraph className="fontFamily1 contactbnr-content contact-hero-subtitle">
              Please let us know how we can improve your experience
            </Typography.Paragraph>
          </div>
        </Row>

        <Row className="whiteBackground contact-main-section" gutter={[24, 24]}>
          <Col xs={24} md={14} className="contact-form-col">
            <div className="contact-section-wrap">
              <Card className="contactCard1 contact-form-card" bordered={false}>
                <form
                  name="insightly_web_to_lead"
                  action="https://crm.na1.insightly.com/WebToLead/Create"
                  method="post"
                  className="contactForm insightly-lead-form"
                  acceptCharset="UTF-8"
                  autoComplete="on"
                >
                  <input type="hidden" name="formId" value="lwa1NcKfUM0Y1FzKDL3QZw==" />
                  <input type="hidden" name="dekv" value="2" />

                  <div className="insightly-field">
                    <label className="insightly-field-label" htmlFor="insightly_firstName">
                      First Name <span className="insightly-required">*</span>
                    </label>
                    <input
                      id="insightly_firstName"
                      name="FirstName"
                      type="text"
                      className="insightly-input"
                      placeholder="First name"
                      required
                    />
                  </div>

                  <div className="insightly-field">
                    <label className="insightly-field-label" htmlFor="insightly_lastName">
                      Last Name <span className="insightly-required">*</span>
                    </label>
                    <input
                      id="insightly_lastName"
                      name="LastName"
                      type="text"
                      className="insightly-input"
                      placeholder="Last name"
                      required
                    />
                  </div>

                  <div className="insightly-field">
                    <label className="insightly-field-label" htmlFor="insightly_organization">
                      Organization
                    </label>
                    <input
                      id="insightly_organization"
                      name="OrganizationName"
                      type="text"
                      className="insightly-input"
                      placeholder="Organization"
                    />
                  </div>

                  <div className="insightly-field">
                    <label className="insightly-field-label" htmlFor="insightly_Email">
                      Email <span className="insightly-required">*</span>
                    </label>
                    <input
                      id="insightly_Email"
                      name="email"
                      type="text"
                      className="insightly-input"
                      placeholder="Email"
                      required
                    />
                  </div>

                  <div className="insightly-field">
                    <label className="insightly-field-label" htmlFor="insightly_Phone">
                      Phone
                    </label>
                    <input
                      id="insightly_Phone"
                      name="phone"
                      type="text"
                      className="insightly-input"
                      placeholder="Phone"
                    />
                  </div>

                  <div className="insightly-field">
                    <label className="insightly-field-label" htmlFor="insightly_EmployeeCount">
                      Number of Employees
                    </label>
                    <input
                      id="insightly_EmployeeCount"
                      name="EmployeeCount"
                      type="text"
                      className="insightly-input"
                      placeholder="e.g. 25"
                    />
                  </div>

                  <div className="insightly-field">
                    <label className="insightly-field-label" htmlFor="insightly_Description">
                      Description
                    </label>
                    <textarea
                      id="insightly_Description"
                      name="Description"
                      className="insightly-textarea"
                      rows={5}
                      placeholder="How can we help?"
                    />
                  </div>

                  <input
                    type="hidden"
                    id="insightly_ResponsibleUser"
                    name="ResponsibleUser"
                    value="533219"
                  />
                  <input
                    type="hidden"
                    id="insightly_LeadSource"
                    name="LeadSource"
                    value="194411"
                  />

                  <div className="insightly-field insightly-field--submit">
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="loginButton contact-submit-btn"
                    >
                      Submit
                    </Button>
                  </div>
                </form>
              </Card>
            </div>
          </Col>
          <Col xs={24} md={6} className="contact-info-col">
            <div className="contact-section-wrap">
              <Card className="contactCard2 contact-info-card" bordered={false}>
                <Row className="contact-info-inner">
                  <Typography.Title className="fontFamily1 contact-info-title">
                    Get in touch with us
                  </Typography.Title>
                  <Typography.Text className="fontFamily1 contact-info-subtitle">
                    Let us know what you want to know. We want to help people learn, grow and
                    achieve more in life.
                  </Typography.Text>

                  <Button
                    type="primary"
                    shape="circle"
                    className="contact-icon-btn"
                    icon={<IoMdPin className="contact-icon" />}
                  />
                  <Typography.Text className="fontFamily1 contact-info-value">
                    1000 Front Street #147 Uniondale, NY 11553
                  </Typography.Text>

                  <Button
                    type="primary"
                    shape="circle"
                    className="contact-icon-btn"
                    icon={<FaEnvelope className="contact-icon" />}
                  />
                  <Typography.Text className="fontFamily1 contact-info-value">
                    info@support.com
                  </Typography.Text>

                  <Button
                    type="primary"
                    shape="circle"
                    className="contact-icon-btn"
                    icon={<BsFillTelephoneFill className="contact-icon" />}
                  />
                  <Typography.Text className="fontFamily1 contact-info-value">
                    +03601 885399
                  </Typography.Text>
                </Row>
                <br />
                <br />
              </Card>
            </div>
          </Col>
        </Row>
      </Layout>
    </>
  );
}

export default ContactUs;
